import React, { FC } from "react";
import { Alert, AlertProps, useTheme } from "@mui/material";

export type IwAlertProps = {
    showBorder?: boolean;
} & AlertProps;

const IwAlert: FC<IwAlertProps> = (props) => {
    const { showBorder, sx, ...otherProps } = props;
    const muiTheme = useTheme();

    return (
        <Alert
            sx={{
                border: `1px solid ${
                    muiTheme.palette[otherProps.severity].main
                }`,
                ...sx,
            }}
            {...otherProps}
        />
    );
};

IwAlert.defaultProps = {
    showBorder: false,
    severity: "info",
};

export default IwAlert;
